import React, { useRef, useState } from 'react'
import authServices from '../../services/UsersService'
import Loading from '../feedback/Loading'
import toast from 'react-hot-toast';
import utils from '../../utils';
import { LuX, LuArrowRight } from "react-icons/lu";

function QuoteForm(props) {
    const [loading, setLoading] = useState(false)
    const nameRef = useRef()
    const emailRef = useRef()
    const textRef = useRef()

    function submitHandler(e){
        const closeBtn = document.getElementById("contact-modal-close-btn")
        setLoading(true)
        e.preventDefault()
        const formdata = new FormData()
        formdata.append("email", emailRef.current.value)
        formdata.append("name", nameRef.current.value)
        formdata.append("description", textRef.current.value)
        authServices.createQuote(formdata).then(
            res => {
                emailRef.current.value = null
                nameRef.current.value = null
                textRef.current.value = null
                toast.success("Quote created, please check your email soon for response.")
                closeBtn.click()
                setLoading(false)
            },
            err => {
                toast.error(utils.toasterError)
                setLoading(false)
            }
        )
    }

    return (
        <div>
            <label htmlFor="contact-modal" id='contact-modal-open-btn' className="hidden"></label>
            <input type="checkbox" id="contact-modal" className="modal-toggle" />
            
            <div className="modal backdrop-blur-md">
                <div className="bg-white w-full max-w-2xl rounded-3xl shadow-[0_40px_80px_-15px_rgba(26,42,74,0.3)] overflow-hidden border border-outline-variant/30 relative">
                    
                    <div className="px-8 py-8 border-b border-outline-variant/10 flex justify-between items-start bg-surface-container-low">
                        <div>
                            <h2 className="text-3xl font-headline font-black text-on-surface tracking-tighter">Request Custom Plan</h2>
                            <p className="text-sm text-on-surface-variant font-bold mt-1">Tailored engineering solutions for your project.</p>
                        </div>
                        <label 
                            htmlFor="contact-modal" 
                            id='contact-modal-close-btn' 
                            className="p-3 hover:bg-error/10 hover:text-error rounded-2xl transition-all cursor-pointer active:scale-90"
                        >
                            <LuX size={24} />
                        </label>
                    </div>

                    <form onSubmit={submitHandler} className="p-8 space-y-6">
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                            <div className="space-y-2">
                                <label className="text-[10px] font-black uppercase tracking-[0.2em] text-primary px-1">Full Name</label>
                                <input 
                                    required 
                                    ref={nameRef} 
                                    name="name"
                                    className="w-full bg-surface-container-low border border-outline-variant/20 rounded-xl px-4 py-4 text-on-surface focus:ring-2 focus:ring-primary focus:border-transparent transition-all outline-none font-medium" 
                                    placeholder="Johnathan Doe" 
                                    type="text"
                                />
                            </div>
                            <div className="space-y-2">
                                <label className="text-[10px] font-black uppercase tracking-[0.2em] text-primary px-1">Email Address</label>
                                <input 
                                    required 
                                    ref={emailRef} 
                                    name="email"
                                    className="w-full bg-surface-container-low border border-outline-variant/20 rounded-xl px-4 py-4 text-on-surface focus:ring-2 focus:ring-primary focus:border-transparent transition-all outline-none font-medium" 
                                    placeholder="j.doe@corporate.com" 
                                    type="email"
                                />
                            </div>
                        </div>

                        <div className="space-y-2">
                            <label className="text-[10px] font-black uppercase tracking-[0.2em] text-primary px-1">Project Description</label>
                            <textarea 
                                required 
                                ref={textRef}
                                className="w-full bg-surface-container-low border border-outline-variant/20 rounded-xl px-4 py-4 text-on-surface focus:ring-2 focus:ring-primary focus:border-transparent transition-all outline-none resize-none font-medium" 
                                placeholder="Detail your structural requirements, site location, and timeline..." 
                                rows="4"
                            ></textarea>
                        </div>

                        <div className="pt-4">
                            {loading ? (
                                <div className="flex justify-center py-4">
                                    <Loading/>
                                </div>
                            ) : (
                                <button 
                                    type="submit"
                                    className="w-full bg-primary text-white py-5 rounded-2xl font-headline font-black text-xs uppercase tracking-[0.3em] shadow-xl shadow-primary/20 hover:bg-primary/90 transition-all active:scale-[0.98] flex items-center justify-center gap-3"
                                >
                                    <span>Send Request</span>
                                    <LuArrowRight size={18} />
                                </button>
                            )}
                        </div>
                    </form>

                    <div className="px-8 py-4 bg-surface-container-highest/30 text-[9px] font-black tracking-[0.2em] text-on-surface-variant/40 flex justify-between items-center border-t border-outline-variant/5">
                        <span className="uppercase">Jahtech System v4.2</span>
                        <span className="uppercase">Secure Transmission Encrypted</span>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default QuoteForm